import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {ActivatedRoute, Route, Router} from "@angular/router";
import {ConfirmationService, MessageService} from "primeng/api";
import {RestBackendService} from "../../service/rest-backend.service";
import {GlobalService} from "../../service/global.service";
import {ConfigService} from "../../service/config.service";
import {JalaliDateCalculatorService, PersianNumberService} from "ngx-persian";
import {slideInAnimation} from "../../route-animation";
import {AdminUser} from "../../dto/AdminUser";
import {Meta} from "@angular/platform-browser";

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.css'],
  animations: [
    slideInAnimation
  ]
})
export class TemplateComponent implements OnInit {

  constructor(protected restBack: RestBackendService,
              public route: Router,
              public activeRoute: ActivatedRoute,
              private metaService: Meta,
              protected messageService: MessageService,
              protected confirmationService: ConfirmationService,
              public global: GlobalService,
              public  config: ConfigService,
              public  jalaliDateCalculatorService: JalaliDateCalculatorService,
              public persianNumberService: PersianNumberService,
              @Inject(LOCALE_ID) public locale: string
  )  { }



  ngAfterContentInit(): void {
    this.metaService.addTags([
      { name: 'keywords', content: $localize`:@@Meta keyword:Meta keyword` },
      { name: 'description', content: 'Search as a service' },
    ]);
  }

  ngOnInit(): void {
    this.checkLogin();
  }


  gotoLogin() {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    this.route.navigate(['/login']).then(() => {
      // window.location.reload();
    });

  }

  logout() {
    var observable = this.restBack.doGet("doc/user/logout");
    observable.then((result: any) => {
      var status = result["status"];
      if (status == 200) {
       this.gotoLogin();
      }
    });
  }
  checkLogin() {
    this.global.progressBar = true;
    var observable = this.restBack.doGet("doc/user/check_login");
    observable.then((result: any) => {
      var status = result["status"];
      if (status == 401) {
       this.gotoLogin();
      }
    }, error => {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: $localize`:@@Error:Error`,
        detail: $localize`:@@Server side error:Server side error`
      });
    }).finally(() => {
      this.global.progressBar = false
    });
  }

  checkValidName(name:string): boolean {
    return !RegExp("^[0-9a-zA-Z-._~]+$").test(name);
  }

  miliSecontToDate(milisecond: number):Date {
    return new Date(milisecond);
  }

  goToOverView() {
    const url = this.route.createUrlTree(["dashboard/overview",this.global.doc,this.global.page]);
    window.open(url.toString(), '_blank')
  }
  // copyToClipboard(text:string) {
  //   var input = document.body.appendChild(document.createElement("input"));
  //   input.value = text;
  //   input.focus();
  //   input.select();
  //   document.execCommand('copy');
  //   // @ts-ignore
  //   input.parentNode.removeChild(input);
  //   this.messageService.clear();
  // this.messageService.add({
  //                           severity: 'error',
  //                           summary: $localize`:@@Error:Error`,
  // detail: $localize`:@@Server side error:Server side error`
// });
  // }
  copyToClipboard(text:string) {
    var input = document.body.appendChild(document.createElement("textarea"));
    input.value = text;
    input.focus();
    input.select();
    document.execCommand('copy');
    // @ts-ignore
    input.parentNode.removeChild(input);
  }
  getHost():string {
    return window.location.host
  }

  getDirection(): string {
    if (this.locale == "fa") {
      return "rtl";
    } else {
      return "ltr";
    }
  }
}
